import { IComponentOptions, IController } from 'angular';
import { $Event } from '../../../helpers';
import './gmc-panel.component.scss';

class GmcPanelCtrl implements IController {
  static $inject = [];
  onClose: ( $event: $Event<any> ) => void;
  header: string;
  extraClasses: string | string[];
  closeBtn: boolean;

  constructor() {
  }

  $onInit() {
  }

  onCloseClick( $event ) {
    this.onClose(new $Event($event));
  }
}

export const GmcPanelComponent: IComponentOptions = {
  controller: GmcPanelCtrl,
  transclude: true,
  template: require('./gmc-panel.component.html'),
  bindings: {
    extraClasses: '<?',
    closeBtn: '<',
    shadow: '<',
    header: '@',
    onClose: '&'
  }
};



// WEBPACK FOOTER //
// ./app/shared/components/gmc-panel/gmc-panel.component.ts